export default __webpack_public_path__ + "cba348a63b3685bbdc2c2ee71b17afa3.svg";